import { Button, Input, Space, Table } from "antd";
import React, { useRef, useState } from "react";
import Style from "./SupplierTable.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, Wallet, XLg } from "react-bootstrap-icons";

const SupplierTable = ({ showAddress, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "نام",
      dataIndex: "fName",
      key: "fName",
      width: "12%",
      ...getColumnSearchProps("fName", "نام "),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(4, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "آیدی تامین کننده",
      dataIndex: "id",
      key: "id",
      width: "12%",
      ...getColumnSearchProps("id", "نام خانوادگی"),
    },
    {
      title: "نام مغازه",
      dataIndex: "marketName",
      key: "marketName",
      width: "12%",
      ...getColumnSearchProps("marketName", "نام مغازه"),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(4, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شماره تلفن",
      dataIndex: "phone",
      key: "phone",
      width: "12%",
      ...getColumnSearchProps("phone", "شماره تلفن"),
    },
    {
      title: "زمان ثبت نام",
      dataIndex: "signUpDate",
      key: "signUpDate",
      width: "12%",
    },
    {
      title: " نوع",
      dataIndex: "type",
      key: "type",
      width: "12%",
      ...getColumnSearchProps("type", "نوع"),
    },
    {
      title: "تعداد کالا ثبت شده",
      dataIndex: "countProduct",
      key: "countProduct",
      width: "12%",
    },
    {
      title: "مجموع سفارش",
      dataIndex: "totalOrder",
      key: "totalOrder",
      width: "12%",
    },
    {
      title: "موجودی حساب",
      dataIndex: "money",
      key: "money",
      width: "12%",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "20%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showAddress(2, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          <button
            onClick={() => showAddress(5, record)}
            className={Style.shabaBtn}
          >
            شبا
          </button>
          {record.status === "1" ? (
            <button
              onClick={() => showAddress(3, record)}
              className={Style.deleteBtn}
            >
              <XLg />
            </button>
          ) : (
            <button
              onClick={() => showAddress(3, record)}
              className={Style.activeBtn}
            >
              <Check2 />
            </button>
          )}
          <button
            onClick={() => showAddress(1, record)}
            className={Style.walletBtn}
          >
            <Wallet />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{x:1500, y: 300 }}
      />
    </div>
  );
};

export default SupplierTable;
